import { render, staticRenderFns } from "./EmployeeSalaryInfo.vue?vue&type=template&id=742d5b39&scoped=true"
import script from "./EmployeeSalaryInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalaryInfo.vue?vue&type=style&index=0&id=742d5b39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d5b39",
  null
  
)

export default component.exports